import IField from "@mapmycustomers/shared/types/fieldModel/IField";
import { MapFilterModel } from "@mapmycustomers/shared/types/viewModel/internalModel/MapFilterModel";

import { getCombinedConditionsCount } from "@app/component/filtering/utils";
import { FILTER_ENTITY_TYPES } from "@app/component/filtering/utils/consts";

export const getAppliedMapFiltersCount = (
  filter: MapFilterModel,
  implicitFilterFields?: IField[]
) => {
  const implicitFilterFieldsNames = new Set((implicitFilterFields ?? []).map(({ name }) => name));

  return FILTER_ENTITY_TYPES.reduce(
    (result, entityType) =>
      result +
      (filter[entityType]
        ? getCombinedConditionsCount(filter[entityType]!, implicitFilterFieldsNames)
        : 0),
    0
  );
};
